module.exports = __webpack_public_path__ + "media/dance/games_worldbeat-fbb1a187.mp3";